import { Component, inject, input } from '@angular/core';
import { TranslatePipe } from '../../../services/translation/translate.pipe';
import { Router } from '@angular/router';
import { BtnComponent } from '../btn/btn.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { ProcessLinkService } from 'ngx-unificator/services';
import { SafePipe } from 'ngx-unificator/pipes';
import { UntilDestroy } from 'ngx-unificator/decorator';
import { ZendeskChatService } from '../../../services/zendesk/zendesk-chat.service';
import { UserAuthService } from '../../../services/user/user-auth.service';
import { LowerCasePipe } from '@angular/common';

@UntilDestroy()
@Component({
  selector: 'app-access-restricted',
  templateUrl: './access-restricted.component.html',
  styleUrls: ['./access-restricted.component.scss'],
  imports: [ReactiveFormsModule, BtnComponent, TranslatePipe, SvgIconComponent, SafePipe, LowerCasePipe],
  host: {
    '[class.modal-view]': 'config().isModalView',
  }
})
export class AccessRestrictedComponent {

  public ze = inject(ZendeskChatService);
  private _userAuth = inject(UserAuthService);
  private _processLink = inject(ProcessLinkService);
  private _router = inject(Router);

  public readonly config = input<{isModalView: boolean, descriptionType: string}>({isModalView: false, descriptionType: 't.account'});

  public onProcessLink(event: MouseEvent) {
    event.preventDefault();
    const link = this._processLink.getHrefFromClickEvent(event);
    if (link) {
      this._userAuth.logoutUser(() => {
        this._router.navigateByUrl(link).then();
      })
    }
  }

  public logout() {
    this._userAuth.logoutUser(() => {});
  }
}
